<template>
  <div class="app-customer-contract-bills-wrapper">
    <div class="current-bill">
      <CurrentBill :show-cta="false" custom-class-name="bills">
        <template v-for="slot in possibleChildSlotsFor('CurrentBill')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </CurrentBill>
    </div>
    <div class="card-wrapper">
      <div class="card">
        <CustomerDocumentList>
          <template v-for="slot in possibleChildSlotsFor('DocumentList')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </CustomerDocumentList>
      </div>
    </div>
    <div class="card-wrapper" v-if="this.loadedContractState && !this.contractTerminated">
      <div class="card">
        <SimonCollapse prid="link-evn-settings">
          <template #headline>
            <slot name="headlineItemised"></slot>
          </template>
          <template #content>
            <ChangeEvnWrapper>
              <template v-for="slot in possibleChildSlotsFor('Evn')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </ChangeEvnWrapper>
          </template>
        </SimonCollapse>
      </div>
    </div>
    <div class="card-wrapper" v-if="this.loadedContractState && !this.contractTerminated">
      <div class="card">
        <SimonCollapse prid="link-bill-settings">
          <template #headline>
            <slot name="headlineBillSettings"></slot>
          </template>
          <template #content>
            <ChangeBillsWrapper>
              <template v-for="slot in possibleChildSlotsFor('ChangeBills')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </ChangeBillsWrapper>
          </template>
        </SimonCollapse>
      </div>
    </div>
  </div>
</template>

<script>

import CustomerDocumentList from '@/components/process/generic/CustomerDocumentList/ConsumerDocumentList.vue'
import ChangeEvnWrapper from './ChangeEvnWrapper.vue'
import ChangeBillsWrapper from './ChangeBillsWrapper.vue'
import customerContractState from '@/mixins/customerContractState'
import SimonCollapse from '@/components/generic/SimonCollapse.vue'
import CurrentBill from '@/components/process/generic/Bill/CurrentBill.vue'

export default {
  name: 'SelfServiceContractBillsWrapper',
  data () {
    return {
      showItemised: false,
      showBillSettings: false,
      refreshKeyBirthDate: 0,
      updateBirthDate: false
    }
  },
  components: {
    CurrentBill,
    CustomerDocumentList,
    ChangeEvnWrapper,
    ChangeBillsWrapper,
    SimonCollapse
  },
  mixins: [
    customerContractState()
  ]
}
</script>
